export enum EInvoiceStatus {
  OK = 'OK',
  ACPT = 'ACPT',
  RJCT = 'RJCT',
  ER = 'ER',
  PC = 'PC',
  PENDING = '',
}

export enum InvoiceStatus {
  OK = 'OK',
  PC = 'PC',
  PENDING = '',
}
